import { Center, useMantineTheme } from "@mantine/core";
import { Logo } from "../../components/Logo";

export default function SplashScreen() {
  const theme = useMantineTheme();
  return (
    <Center
      sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Logo white={theme.colorScheme === "dark"} />
    </Center>
  );
}
